import { animate, style } from '@angular/animations';
import {
  AfterViewInit,
  Component,
  ElementRef,
  HostListener,
  inject,
  Renderer2,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { NgbDropdown, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import KeenSlider, { KeenSliderInstance } from 'keen-slider';
import { NgxMasonryOptions } from 'ngx-masonry';
import {
  NgbCalendar,
  NgbDatepickerModule,
  NgbDateStruct,
} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-ui-landing',
  templateUrl: './ui-landing.component.html',
  styleUrls: ['./ui-landing.component.scss'],
})
export class UiLandingComponent implements AfterViewInit {
  @ViewChild('sliderRef') sliderRef!: ElementRef<HTMLElement>;
  @ViewChild('filterDropdownMenu') filterDropdownMenu: ElementRef;
  @ViewChild('myDrop') myDrop: NgbDropdown;

  currentSlide: number = 1;
  dotHelper: Array<Number> = [];
  slider!: KeenSliderInstance;

  isSearchBarActive = false;
  typeSelect!: number;

  constructor(private elRef: ElementRef, private renderer: Renderer2) {}

  viewSearchBar() {
    const windowWidth = window.innerWidth;
    if (windowWidth < 767) {
      this.isSearchBarActive = !this.isSearchBarActive;
    }
  }

  @HostListener('document:click', ['$event'])
  handleOutsideClick(event: Event) {
    if (!this.elRef.nativeElement.contains(event.target)) {
      this.isSearchBarActive = false;
    }
  }
  @HostListener('window:scroll', ['$event'])
  onScroll() {
    if (this.myDrop.isOpen()) {
      this.myDrop.close();
    }
  }

  public masonryOptions: NgxMasonryOptions = {
    resize: true,
    // horizontalOrder: true,
    initLayout: true,
    animations: {
      show: [
        style({ opacity: 0 }),
        animate('400ms ease-in', style({ opacity: 1 })),
      ],
      hide: [
        style({ opacity: '*' }),
        animate('400ms ease-in', style({ opacity: 0 })),
      ],
    },
  };

  ngAfterViewInit() {
    this.slider = new KeenSlider(
      this.sliderRef.nativeElement,
      {
        initial: this.currentSlide,
        slideChanged: (s) => {
          this.currentSlide = s.track.details.rel;
        },
        loop: true,
      },
      [
        (slider) => {
          let timeout: any;
          let mouseOver = false;
          function clearNextTimeout() {
            clearTimeout(timeout);
          }
          function nextTimeout() {
            clearTimeout(timeout);
            if (mouseOver) return;
            timeout = setTimeout(() => {
              slider.next();
            }, 3000);
          }
          slider.on('created', () => {
            slider.container.addEventListener('mouseover', () => {
              mouseOver = true;
              clearNextTimeout();
            });
            slider.container.addEventListener('mouseout', () => {
              mouseOver = false;
              nextTimeout();
            });
            nextTimeout();
          });
          slider.on('dragStarted', clearNextTimeout);
          slider.on('animationEnded', nextTimeout);
          slider.on('updated', nextTimeout);
        },
      ]
    );
    this.dotHelper = [...Array(this.slider.track.details.slides.length).keys()];
  }

  ngOnDestroy() {
    if (this.slider) this.slider.destroy();
    this.renderer.removeClass(document.body, 'landing-page-body');
  }

  active = 'place';
  activeInner = 'type-of-meal';

  // Code for adding class only for landing page.
  ngOnInit() {
    this.renderer.addClass(document.body, 'landing-page-body');
  }

  // Modal Code
  private modalService = inject(NgbModal);
  openViewArticleModal(viewArticleModal: TemplateRef<any>) {
    this.modalService.open(viewArticleModal, {
      windowClass: 'project-modal view-article-modal',
      centered: true,
      backdropClass: 'primary-backdrop',
      size: 'xl',
      scrollable: true,
    });
  }

  model: NgbDateStruct;
  placement = 'top';

  types = [
    { id: 1, name: 'Restaurant' },
    { id: 2, name: 'Cafe' },
    { id: 3, name: 'Other' },
    { id: 4, name: 'Other' },
  ];
}
